import * as Constants from '../constants/activity';

const initialState = {
  userActivityTypes: [],
  activeActivityType: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_USER_ACTIVITY_TYPES_SUCCESS:
      return {
        ...state,
        userActivityTypes: action.payload,
      };
    case Constants.GET_USER_ACTIVITY_TYPE_SUCCESS:
      return {
        ...state,
        activeActivityType: action.payload,
      };
    case Constants.CLEAR_USER_ACITIVITY_TYPE:
      return {
        ...state,
        activeActivityType: null,
      };
    default:
      return state;
  }
};
